module.exports = __webpack_public_path__ + "img/nologin_phone_fortune_telling_pc.dc4e553.png";